import { httpGetResponse } from '../../../api/httpClient';
import { DELIVERY_MAP_PAGE_SIZE, DeliveryMapPage, DeliveryMapParams, DeliveryMapZone } from './deliveryMapTypes';

export const deliveryMapUrls = { geometry: '/v1/delivery-map/geometry' } as const;

export async function getDeliveryMapGeometry(params: DeliveryMapParams, signal?: AbortSignal): Promise<DeliveryMapPage> {
  const query: Record<string, string> = {
    west: String(params.west), south: String(params.south), east: String(params.east), north: String(params.north),
    page: String(params.page), per_page: String(DELIVERY_MAP_PAGE_SIZE),
  };
  if (params.zone_region_id !== undefined) query.zone_region_id = String(params.zone_region_id);
  const response = await httpGetResponse<DeliveryMapZone[]>(deliveryMapUrls.geometry, query, signal, 'no-store');
  const { page, per_page, total, page_count } = response.meta;
  if (!response.success || !Array.isArray(response.data) || typeof page !== 'number' || typeof per_page !== 'number' || typeof total !== 'number' || typeof page_count !== 'number') {
    throw new Error('Не удалось прочитать зоны карты. Повторите загрузку.');
  }
  return { items: response.data, meta: { page, per_page, total, page_count } };
}
